// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jr-0";